export type EntitySelectItem = {
  id: string;
  title?: string;
  url?: string;
  parentId?: string;
};

type SelectedItemChangedEvent = CustomEvent<{
  value?: EntitySelectItem;
}>;

/**
 * Navigate when the admin header entity picker selects an item (uses item.url from items JSON).
 */
export function navigateForSelectedEntityItem(item: EntitySelectItem | undefined | null): boolean {
  if (!item?.url) {
    return false;
  }

  const targetPath = item.url.startsWith('/')
    ? item.url.split('?')[0].split('#')[0]
    : (() => {
        try {
          return new URL(item.url, globalThis.location.origin).pathname;
        } catch {
          return '';
        }
      })();

  if (!targetPath) {
    return false;
  }

  if (targetPath === globalThis.location.pathname) {
    return false;
  }

  globalThis.location.assign(targetPath);
  return true;
}

export async function setupOrganisationDropdownListeners(): Promise<void> {
  await customElements.whenDefined('cbar-entity-select');

  const organisationDropdown = document.querySelector(
    '#organisation_select'
  ) as CbarEntitySelectElement | null;

  if (!organisationDropdown || organisationDropdown.dataset.orgNavBound === 'true') {
    return;
  }

  organisationDropdown.dataset.orgNavBound = 'true';

  // selected-item-changed fires before the host `value` property updates — use detail.value.
  organisationDropdown.addEventListener('selected-item-changed', (event: Event) => {
    const item = (event as SelectedItemChangedEvent).detail?.value;
    navigateForSelectedEntityItem(item);
  });
}

function setupHeaderSearch() {
  document.addEventListener('search-submitted', (e: Event) => {
    const detail = (e as CustomEvent<string>).detail;
    if (detail) {
      window.location.href =
        '/admin/searchentities?search_string=' + encodeURIComponent(detail);
    }
  });
}

export function handleHeaderSidenav() {
  setupHeaderSearch();
}
